import React from 'react'

type Props = {
  localVideoRef: React.RefObject<HTMLVideoElement>
}

const MyCamera = (props: Props) => {
  const { localVideoRef } = props
  return (
    <div className="w-full flex-1 flex-col flex justify-end">
      <video
        ref={localVideoRef}
        autoPlay
        playsInline
        style={{
          aspectRatio: '16/12',
          backgroundColor: 'black'
        }}
        muted
        className="min-w-[18rem] z-50 overflow-hidden w-full rounded-md border border-black transform scale-x-[-1]"></video>
    </div>
  )
}

export default MyCamera
